import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import wrangler from "../../../../assets/info/wrangler-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import { popularVehicle } from "../../../../vars/popularVehicles";

const JeepWrangler = () => {
  useSmallNav("Jeep Wrangler");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Jeep Wrangler"} bolder />
        <InfoHero image={wrangler} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={
                "Do you own and drive a Jeep Wrangler? Looking for suspension parts or suspension upgrades?"
              }
            />
            <InfoHeader
              size="smaller"
              text={"Then you have come to the right place."}
            />
            <p>
              The iconic Jeep Wrangler is great vehicle, still retaining that
              classic Wrangler look.
            </p>
            <p>
              Here at Pedders Suspension we have invested heavily in a range of
              suspension parts, in particular the 2007 on JK Wrangler, to
              improve the look, comfort and handling of your Wrangler.
            </p>
            <p>
              We offer spring options to suit various uses, light duty, heavy
              duty, short wheelbase, long wheelbase, diesel or petrol.
            </p>
            <p>
              Specifically designed so as not in invoke the infamous “death
              wobble” , our kits also include our Pedders foam cell steering
              damper.
            </p>
            <p>
              Like our steering damper, our shocks all feature Pedders Foam cell
              technology. For more details of this, please see the video to the
              right.
            </p>
            <p>
              In addition to our springs and shocks, we also offer a range of
              other suspension related components such as panhard rods, ball
              joints, bushes etc.
            </p>
            <p>
              Not sure which kits or parts you require? Then please do get in
              touch, where one of our team will be able to assist you.
            </p>
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/-x9r6VqbGrg"
              title={"Jeep Wrangler Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              title={"Jeep Wrangler Video 2"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Jeep")
              .models.find((e) => e.display === "Wrangler")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
          </div>
        </InfoGrid>
      </Container>
    </section>
  );
};

export default JeepWrangler;
